import axios from 'axios';
// axios.defaults.withCredentials = true;
axios.interceptors.response.use(
    (response: any) => {
        if (response.status === 200) {
            return response.data;
        } else {
            return response;
        }
    },
    (error: any) => {
        return Promise.reject(error);
    },
);
export const fetch = axios;

let { VUE_APP_HTTP_PREFIX: http_prefix } = process.env;
console.log('http_prefix', http_prefix);
export const classVerify = http_prefix + '/class/verify'; // 验证房间密码
export const classToken = http_prefix + '/class/token'; // 获取token
export const classRoomlist = http_prefix + '/class/roomlist'; // 查询房间
export const classCreate = http_prefix + '/class/create'; //  创建房间
export const classModify = http_prefix + '/class/modify'; //  更新房间
export const classDelete = http_prefix + '/class/delete'; //  删除房间
export const classTitle = http_prefix + '/class/title'; // 修改标题
export const classLogout = http_prefix + '/class/logout'; // 登出
export const classLogin = http_prefix + '/class/login'; // 登录
export const classRoom = http_prefix + '/class/room'; //查询房间存在
export const appAdd = http_prefix + '/class/app/add'; //添加appId
export const appModify = http_prefix + '/class/app/modify'; //更新appId
export const flowLimit = http_prefix + '/class/flow/limit'; //查询限流
export const appSign = http_prefix + '/class/app/info'; // 查询appSign
